module.exports = __webpack_public_path__ + "img/image20.0e73682b.png";